export const STORAGE_KEY = '@EVD';

export const getQueryKey = (caseId: string) => `${STORAGE_KEY}_${caseId}`;

export const setDisqualifiedId = (caseId: string) => {
  try {
    localStorage.setItem(getQueryKey(caseId), JSON.stringify(new Date()));
    return true;
  } catch (e) {
    return false;
  }
};

export const getDisqualifiedId = (caseId: string) => {
  try {
    const value = localStorage.getItem(getQueryKey(caseId));
    return !!value;
  } catch (e) {
    return false;
  }
};
